/* Repair a third-party review tab only when its panel explicitly names it. */
(() => {
  const root = document.getElementById('ReviewsWidget');
  if (!root) return;
  const repair = () => {
    const panels = [...root.querySelectorAll('[role="tabpanel"][id]')];
    root.querySelectorAll('[role="tab"][id][aria-controls]').forEach((tab) => {
      const panel = panels.find((item) =>
        (item.getAttribute('aria-labelledby') || '').split(/\s+/).includes(tab.id)
      );
      if (panel && tab.getAttribute('aria-controls') !== panel.id) {
        tab.setAttribute('aria-controls', panel.id);
      }
    });
  };
  repair();
  new MutationObserver(repair).observe(root, { childList: true, subtree: true });
})();
